// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17lqf","colMin":"styles_colMin__7F0wP"};